export type FeePreview = {
  feeAtomic: string;
  payableAtomic: string;
  profitAtomic?: string;
};

export function calculateFeePreview(priceAtomic: string, feeBps: number, internalCostAtomic?: string): FeePreview {
  if (!/^\d+$/.test(priceAtomic) || !Number.isInteger(feeBps) || feeBps < 0 || feeBps > 10000) {
    throw new Error("invalid fee preview input");
  }
  const price = BigInt(priceAtomic);
  const fee = price * BigInt(feeBps) / 10000n;
  const payable = price - fee;
  const result: FeePreview = { feeAtomic: fee.toString(), payableAtomic: payable.toString() };
  if (internalCostAtomic !== undefined && internalCostAtomic !== "") {
    if (!/^\d+$/.test(internalCostAtomic)) throw new Error("invalid internal cost");
    result.profitAtomic = (payable - BigInt(internalCostAtomic)).toString();
  }
  return result;
}
